var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4993 50.4166C80.545 50.4166 100.833 43.4893 100.833 30.2499C100.833 17.0105 80.545 10.0833 60.4993 10.0833C40.4537 10.0833 20.166 17.0105 20.166 30.2499C20.166 43.4893 40.4537 50.4166 60.4993 50.4166Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.166 50.4166C20.166 63.656 40.4537 70.5833 60.4993 70.5833C80.545 70.5833 100.833 63.656 100.833 50.4166V40.3333C100.833 53.5727 80.545 60.4999 60.4993 60.4999C40.4537 60.4999 20.166 53.5727 20.166 40.3333V50.4166Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.166 70.5833C20.166 83.8227 40.4537 90.75 60.4993 90.75C80.545 90.75 100.833 83.8227 100.833 70.5833V60.5C100.833 73.7394 80.545 80.6667 60.4993 80.6667C40.4537 80.6667 20.166 73.7394 20.166 60.5V70.5833Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.166 90.7501C20.166 103.989 40.4537 110.917 60.4993 110.917C80.545 110.917 100.833 103.989 100.833 90.7501V80.6667C100.833 93.9062 80.545 100.833 60.4993 100.833C40.4537 100.833 20.166 93.9062 20.166 80.6667V90.7501Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.6ca6f639765833ffacfa8f3f43bc2d1b.svg";
export { ForwardRef as ReactComponent };